export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const CLEAR_ORGANIZATIONS = 'CLEAR_ORGANIZATIONS';
